var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTranslations } from '@storebrand-digital/fms-translations-react';
import { Link } from './styled';
function DefaultLinks() {
    var _a = useTranslations(), getJSON = _a.getJSON, language = _a.language;
    return (React.createElement(React.Fragment, null, getJSON('footer.links')
        .map(function (_a) {
        var href = _a.href, title = _a.title, props = __rest(_a, ["href", "title"]);
        return (React.createElement(Link, __assign({ key: title[language], href: href }, props), title[language]));
    })));
}
export default DefaultLinks;
